import React from 'react'
import PropTypes from 'prop-types'
import BaseImage from 'components/Image/SimpleImage'

export const Image = ({ src: propSource, fallbackSrc, ...restProps }) => {
  const [src, setSrc] = React.useState(propSource)
  const [isError, setIsError] = React.useState(false)

  const onError = () => {
    if (!isError) {
      setSrc(fallbackSrc)
      setIsError(true)
    }
  }

  const validURL = str => {
    const pattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$',
      'i',
    ) // fragment locator
    return !!pattern.test(str)
  }

  return !src && !fallbackSrc ? null : (
    <BaseImage
      src={
        !!src
          ? src.startsWith('/') || validURL(src) || src.startsWith('data:image')
            ? src
            : '/'.concat(src)
          : fallbackSrc
      }
      onError={onError}
      quality={50}
      priority
      {...restProps}
    />
  )
}

Image.propTypes = {
  src: PropTypes.any,
  fallbackSrc: PropTypes.string,
}

export default Image
